import styled from "styled-components";

export const Container = styled.div`
  width: 100%;
  height: 100%;
  background-color: var(--color-white);
  border-radius: 8px;
  @media (max-width: 500px) {
    width: 100%;
  }
  button {
    width: 290px;
    height: 40px;
    border: 2px solid var(--color-latex30);
    color: var(--color-latex30);
    border-radius: 8px;
    background: transparent;
    font-size: 18px;
    margin: 15px;
  }
  .cruz {
    font-size: 18px;
  }
`;

export const Top = styled.div`
  height: 54px;
  background: var(--color-latex30);
  color: var(--color-white);
  display: flex;
  justify-content: center;
  align-items: center;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  span {
    font-weight: bold;
    font-size: 18px;
  }
`;

export const BodyModal = styled.div`
  display: flex;
  flex-direction: column;
  height: 60vh;
  width: 90vh;
  padding: 10px 40px;
  align-items: flex-start;
  overflow-x: hidden;
  overflow-y: scroll;
  .sectionStyles {
    margin-bottom: 20px;
  }

  .letterStyles {
    text-align: left;
    margin-bottom: 10px;
    font-weight: bold;
    color: #333;
  }

  .ulStyles {
    display: flex;
    flex-wrap: wrap;
    gap: 50px;
    list-style-type: none;
    padding: 0;
    margin: 0;
  }

  .liStyles {
    text-align: left;
    width: 180px;
    margin-bottom: 5px;
  }
`;

export const BuscadorBox = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
  justify-content: flex-start;
  align-items: flex-start;
  padding: 20px 0;
  .buscadorEsp {
    width: 100%;
    height: 38px;
    border: 1px solid var(--color-grey65);
    border-radius: 4px;
    padding: 18px 8px;
    color: var(--color-latex30);
  }
  .buscadorEsp:focus {
    border: 2px solid var(--color-latex30); /* Cambia el grosor y el color del borde */
    outline: none; /* Opcional: elimina el borde predeterminado */
  }
`;

export const Line = styled.div`
  position: relative; /* Necesario para posicionar los pseudo-elementos */
  height: 1px; /* Altura de la línea */
  width: 20vh;
  margin: 16px 0; /* Espaciado superior e inferior */

  &::before {
    content: ""; /* Esto asegura que el pseudo-elemento se renderice */
    position: absolute;
    top: 50%;
    left: 0;
    right: 0;
    height: 2px; /* Grosor de la línea */
    background: linear-gradient(
      to right,
      rgba(0, 0, 0, 0),
      var(--color-grey85),
      rgba(0, 0, 0, 0)
    ); /* Gradiente difuminado */
    transform: translateY(-50%); /* Centra el pseudo-elemento verticalmente */
  }
`;

export const BtnAplicarWrapper = styled.div`
  position: sticky;
  bottom: 0;
  width: 100%;
  display: flex;
  justify-content: center;
  padding: 24px 0 16px;
  margin-top: auto;
  background: rgba(255, 255, 255, 0.92);

  .btn-aplicar {
    min-width: 200px;
    height: 44px;
    border: none;
    border-radius: 8px;
    background-color: var(--color-primary);
    color: var(--color-white);
    font-size: 18px;
    font-weight: 500;
    cursor: pointer;
  }
`;
